<template>
  <!-- 产品功能区域 -->
  <section class="payment-icons-section d-flex align-items-center">
    <div class="container px-5 payment-icons-container">
      <div class="row justify-content-center m-3 title">
        安全第一嚴格保護你的帳戶
      </div>
      <div class="row g-5">
        <div class="col-md-4" v-for="(item, index) in list">
          <div class="d-flex content" :class="getClassObject(index)">
            <div class="info">
              <div class="img-border d-flex justify-content-center align-items-center"  >
                <img :src="getImage(item.imgSrc)" class="img-fluid" :style="item.style">
              </div>
              <div class="subtitle d-flex justify-content-center">{{ item.title }}</div>
              <div class="desc d-flex justify-content-center">{{ item.desc }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'SafeAccount',
  props: {
    list: {
      type: Array,
      required: true,
      validator: value => value.length > 0
    },
  },
  data() {
    return {
    }
  },
  computed: {
    
  },
  methods: {
    getImage(name) {
      return require(`@/assets/uupay/images/${name}.png`)
    },
    getClassObject: function (index) {
      return {
        'justify-content-end': index % 3 == 0,
        'justify-content-center': index % 3 == 1,
        'justify-content-start': index % 3 == 2,
      }
    }
  }
}
</script>
<style scoped>
.payment-icons-section {
  background-color: #f8f8f8;
  color: #21042e;
  font-weight: 400;
  padding: 5rem 0;
}

@media (min-width: 1700px) {
  .modules-section-container {
    max-width: 1440px;
  }
}


.payment-icons-container .title {
  font-size: 42px;
  line-height: 60px;
  font-weight: 600;
  padding: 2rem 0;
}
.payment-icons-container .content {
  margin: 2rem 0;
}
.payment-icons-container .info {
  background-color: #fff;
  width: 300px;
  height: 290px;
  border-radius: 20px;
  border: 1px solid #f5f5f5;
  /*display: flex;
  flex-direction: column;
  justify-content: space-around;*/
}
.payment-icons-container .img-border {
  margin: 1.5rem 0;
}

.payment-icons-container .payment-icon {
  
}
.payment-icons-container .subtitle {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 1.4rem;
}
.payment-icons-container .desc {
  font-size: 14px;
  line-height: 26px;
  color: #76667c;
  width: 80%;
  margin: 0 auto;
}
</style>


// WEBPACK FOOTER //
// src/components/SafeAccount.vue